import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import classes from './NewsItem.module.css'
import { ThemeContext } from '../../../App'
import { ImageNotSupportedIcon } from '../../../icons/ImageNotSupported'


export interface NewsItemProps {
    image: string | undefined,
    url: string,
    title: string,
    author: string | null,
    published: string,
    description: string
}

export default function NewsItem({ image, url, title, author, published, description }: NewsItemProps) {

    const { theme } = useContext(ThemeContext)

    return (
        <div id={classes[theme]} className='w-full md:w-11/12 md:mx-auto lg:w-11/36 flex flex-col mb-bottom-vh7 lg:mb-bottom-vh12 justify-between'>
            <div>
                <div className={classes.imgDiv + " w-full h-vh24 md:h-vh30"}>
                  
                    {  image ?  <img src={image} className={' w-full'} /> : <div className={classes.imageNotFound}><ImageNotSupportedIcon styles={{width: 60, height: 60}} iconColor={theme === "dark" ? "white" : "black"}/></div>}
                </div>
                <h4 className='text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lgSepBtnTxt w-11/12 ml-3 mt-4'>{title}</h4>
                <p className='text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt ml-3 mt-1 hidden lg:block'>By: <span>{author}</span> | {published.substring(0, 10)}</p>
                <p className='text-smAdd2Txt md:text-mdAddTxt lg:text-lg2AddTxt ml-3 mt-5 w-11/12'>{description}</p>
            </div>

            <div className='flex justify-end mr-6 md:mb-6 md:mr-10 mb-4'>
                <Link to={url} className={classes.contactBtn + " text-smSepBtnTxt p-2vh4vw lg:p-0 mr-0 md:text-mdSepBtnTxt lg:text-lgSepBtn2Txt lg:p-2vh4vw"}>Read Article</Link>
            </div>

        </div>
    )
}
